<template>


    <b-modal class="modal fade" ref="agreement-modal" centered size="md" scrollable style="padding: 10px"
        @hide="onModalHide">

        <template v-slot:modal-header>
            <slot name="header">
                <h6 class="modal-title">REFERRAL SERVICE AGREEMENT</h6>
            </slot>
            <slot name="close-button">
                <button type="button" class="close" @click="goToDashboard" data-dismiss="modal" aria-label="Close">
                    <span>×</span>
                </button>
            </slot>
        </template>

        <div id="consentModal" style="height: 300px; width: 100%; margin-bottom: 20px; font-size: 14px !important;">

            <b-row>
                <b-col class="less-padding" style="margin: 0px 20px 0px 10px;">
                    <base-input name="Accept">
                        <b-form-checkbox v-model="confirmedTerms">

                            <span style="font-size: 10pt">I confirm that I:</span>

                        </b-form-checkbox>
                    </base-input>
                </b-col>
            </b-row>


            <b-row>

                <b-col class="less-padding">
                    <ul>
                        <!-- <li>You are acting as a referrer only – not an insurance broker or adviser.</li>
                        <li>You only send basic contact and finance/asset details to Transport Protect.</li>
                        <li>All insurance advice, quoting and binding is handled by Transport Protect Underwriting under
                            AFSL
                            241055.</li> -->


                        <li>am aware of, and understand, the terms of the Referral Agreement with Transport Protect;
                        </li>
                        <li>have obtained the client&#39;s consent to be contacted by Transport Protect for an insurance
                            quote;
                        </li>

                        <li>have disclosed to the client that I may receive a referral fee if they purchase a policy;
                            and</li>
                        <li>have not provided any financial advice regarding this insurance.</li>
                    </ul>

                </b-col>

            </b-row>



        </div>

        <template v-slot:modal-footer>
            <b-button icon @click="goToDashboard">Decline</b-button>
            <b-button style="background-color: #ff4438; color: white" type="danger" :disabled="confirmedTerms == false"
                icon @click="acceptTerms()">Accept & continue</b-button>
        </template>

    </b-modal>

</template>

<script>
//import MotorContinueQuote from "../../components/MotorContinueQuote.vue";
import BaseInput from "../../../components/Inputs/BaseInput.vue";
import { Select, Option, DatePicker } from "element-ui";
import VueMultiselectComponent from 'vue-multiselect-component'
import { entsiaDropDowns } from "../../../assets/data/entsiaLOVs";
import { entsiaFunctions } from "../../../helpers/entsia";
import { GlobalStore } from "../../../globalStore";
import { getMotorReferralAcceptedSessionKey } from "../../../helpers/motorReferralAgreement";
import { toasts } from "../../../helpers/toasts";

export default {
    name: "AgreementModal",
    data() {
        return {
            editMode: 'add',
            confirmedTerms: false,
            selectedItem: null,
            selectedIdx: null,
            freightTaskOptions: entsiaDropDowns.freightTaskOptions,
            vehicleTypeOptions: entsiaDropDowns.vehicleTypeOptions,
            pickerOptions: {},
            /** When true, next `hide` was triggered after successful Accept — do not redirect. */
            _hideFromAccept: false
        }
    },
    methods: {
        goToDashboard() {
            this.$router.push("/dashboard").catch(() => { });
        },
        async acceptTerms() {
            try {
                await entsiaFunctions.acceptReferralTerms(
                    { Broker_id: GlobalStore.brokerObj.Broker_id }
                );
            } catch (e) {
                toasts.error(
                    (e && e.message) || "Could not save referral terms. Please try again."
                );
                return;
            }

            const key = getMotorReferralAcceptedSessionKey();
            sessionStorage.setItem(key, "true");

            this._hideFromAccept = true;
            this.$refs['agreement-modal'].hide();
            this.$emit("accepted");
        },
        saveClaim() {
            this.$emit('saveClaim', this.selectedItem);
            this.$refs['claim-modal'].hide();
        },
        /**
         * Backdrop click, ESC, or programmatic hide after Accept.
         */
        onModalHide(bvEvt) {
            if (this._hideFromAccept) {
                this._hideFromAccept = false;
                return;
            }
            this.$router.push("/dashboard").catch(() => { });
        },
        openModal() {
            this.confirmedTerms = false;
            this._hideFromAccept = false;
            this.$refs['agreement-modal'].show();
        },
    },
    components: {
        BaseInput,
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
        VueMultiselectComponent
    },
    async mounted() {
    }
};
</script>
<style scoped lang="scss">
#consentModal {

    h1 {
        text-align: center;
        font-size: 1.6em;
        margin-bottom: 30px;
        letter-spacing: 1px;
    }

    .parties {
        margin-bottom: 30px;
    }

    .parties p {
        margin: 8px 0;
    }

    .parties strong {
        display: inline-block;
        margin-bottom: 4px;
    }

    h2 {
        font-size: 1.1em;
        margin-top: 28px;
        margin-bottom: 10px;
    }

    p,
    li {
        font-size: 0.95em;
    }

    ol.clauses {
        list-style: none;
        padding-left: 0;
    }

    ol.clauses>li {
        margin-bottom: 6px;
    }

    ol.sub {
        list-style: lower-alpha;
        padding-left: 30px;
        margin-top: 6px;
    }

    ol.sub>li {
        margin-bottom: 4px;
    }

    table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 10px;
    }

    table th,
    table td {
        border: 1px solid #999;
        padding: 10px 14px;
        text-align: left;
        vertical-align: top;
        font-size: 0.95em;
    }

    table th {
        background: #f0f0f0;
        font-weight: bold;
        width: 160px;
    }

    ol {
        list-style-type: none;
    }
}
</style>
